export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DatabaseWorker.4650f828.worker.js");
}
